const colorsNegative = [
  { threshold: 10, bg: '#FBECEA', color: '#31363B' },
  { threshold: 20, bg: '#F7DAD4', color: '#31363B' },
  { threshold: 30, bg: '#F3C7BF', color: '#31363B' },
  { threshold: 40, bg: '#EFB5A9', color: '#31363B' },
  { threshold: 50, bg: '#EBA294', color: '#31363B' },
  { threshold: 60, bg: '#E78F7E', color: '#31363B' },
  { threshold: 70, bg: '#E27D69', color: '#FFFFFF' },
  { threshold: 80, bg: '#DE6A54', color: '#FFFFFF' },
  { threshold: 90, bg: '#DA583E', color: '#FFFFFF' },
  { threshold: Infinity, bg: '#D64529', color: '#FFFFFF' },
]

const colorsPositive = [
  { threshold: 10, bg: '#E9F4D7', color: '#31363B' },
  { threshold: 20, bg: '#DEEEC3', color: '#31363B' },
  { threshold: 30, bg: '#D3E9AF', color: '#31363B' },
  { threshold: 40, bg: '#C8E39C', color: '#31363B' },
  { threshold: 50, bg: '#BCDD88', color: '#31363B' },
  { threshold: 60, bg: '#B1D874', color: '#31363B' },
  { threshold: 70, bg: '#A6D260', color: '#31363B' },
  { threshold: 80, bg: '#9BCD4C', color: '#31363B' },
  { threshold: 90, bg: '#90C738', color: '#31363B' },
  { threshold: Infinity, bg: '#82B332', color: '#FFFFFF' },
]

const determineColor = (percentage, colors) => {
  const absolutePercentage = Math.abs(percentage)
  for (let i = 0; i < colors.length; i++) {
    if (absolutePercentage <= colors[i].threshold) {
      return {
        color: colors[i].color,
        bg: colors[i].bg,
      }
    }
  }
}

const getCellColor = (percentage) => {
  if (percentage === '0.00') return { color: '#31363B', bg: '#FFFFFF' }
  if (percentage < 0) return determineColor(percentage, colorsNegative)
  else return determineColor(percentage, colorsPositive)
}

export default getCellColor
